
import { useEffect } from 'react';
import { signIn } from 'next-auth/react';
import type { NextPage } from 'next';
import { UI_Spinner } from 'ui/components/1-atoms/Media/Spinner/Spinner';

const LoginPage: NextPage = () => {
    useEffect(() => {
        void signIn('auth0', { callbackUrl: `${window.location.origin}/oversigt` });
    }, []);

    return (
        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
            <UI_Spinner loadingLabel="Logger ind..." />
        </div>
    );
};

export default LoginPage;